var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeaderBackground = function SvgHeaderBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 541,
    height: 698,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#header-background_svg__a)",
    d: "M308.307 683.902c-194.737-77.29-98.843-194.961-206.828-254.983-185.677-103.207-85.006-313.002 60.238-310.343 110.56 2.025 110.588 56.349 202.59-25.344 92.002-81.694 373.724-162.98 370.615 6.786-3.314 180.95-120.353 90.771-125.978 397.907-2.291 125.149-166.981 239.024-300.637 185.977Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-background_svg__a",
    x1: 405,
    x2: 105.801,
    y1: -208.5,
    y2: 519.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B0D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#40C700"
  })))));
};
export default SvgHeaderBackground;